import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    standalone: false
})
export class ModalComponent implements OnInit {
  ngOnInit(): void {
  }

  @Input('isShow') isShow: boolean
  @Input('header') header: string
  @Input('style') style: string = ''
  @Input() appendTo: any = null

  @Output('cancel') cancel = new EventEmitter<any>()


  onCancel() {
    this.cancel.emit()
  }
}
